module.exports = __webpack_public_path__ + "static/media/ramanujan-logo.9abcc782.png";